export default __webpack_public_path__ + "static/media/lock.93f835d3.svg";